export const ADMIN_SESSION_TYPE_KEY = 'wavelink:session-type';
export const ADMIN_SESSION_TYPE = 'admin' as const;
export const ADMIN_USER_STORAGE_KEY = 'wavelink:admin-user';
export const CONTROL_SIDEBAR_COLLAPSED_KEY = 'wireless-console.sidebar-collapsed';

export interface AdminUser {
  username: string;
}

export function isAdminSession(): boolean {
  if (typeof sessionStorage === 'undefined') {
    return false;
  }
  return sessionStorage.getItem(ADMIN_SESSION_TYPE_KEY) === ADMIN_SESSION_TYPE;
}

export function setAdminSession(username: string): void {
  sessionStorage.setItem(ADMIN_SESSION_TYPE_KEY, ADMIN_SESSION_TYPE);
  localStorage.setItem(ADMIN_USER_STORAGE_KEY, JSON.stringify({ username }));
}

export function clearAdminSession(): void {
  sessionStorage.removeItem(ADMIN_SESSION_TYPE_KEY);
  localStorage.removeItem(ADMIN_USER_STORAGE_KEY);
}

export function getStoredAdminUser(): AdminUser | null {
  try {
    const raw = localStorage.getItem(ADMIN_USER_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as AdminUser;
    return parsed?.username ? parsed : null;
  } catch {
    return null;
  }
}
